import { useEffect } from "react"
import { H1 } from "components/ui/typography/titles/Titles"
import { useGetReleases } from "hooks/api/releaseInformation/releaseInformation.hook"
import { ChangelogItem } from "./layout/ChangelogItem/ChangelogItem"
import { Skeleton } from "components/ui/skeleton/Skeleton"
import type { TRelease } from "types/releaseInformation.type"
import style from "./Changelog.module.scss"

const { changelog, skeleton } = style

export const Changelog = () => {
	const { data: releases, isPending: isReleasePending } = useGetReleases()

	useEffect(() => {
		if (!isReleasePending && releases && window.location.hash) {
			const hash = window.location.hash.slice(1)
			const element = document.getElementById(hash)
			if (element) {
				setTimeout(() => {
					element.scrollIntoView({ behavior: "smooth", block: "start" })
				}, 100)
			}
		}
	}, [isReleasePending, releases])

	return (
		<div className={changelog}>
			<H1>Changelog</H1>
			{isReleasePending ? (
				<div className={skeleton}>
					<Skeleton rows={12} />
				</div>
			) : (
				releases?.map((item: TRelease, index: number) => <ChangelogItem changeLogData={item} key={index} />)
			)}
		</div>
	)
}
